/**
 * チャット機能
 * エントリーポイント - ロジックとUIを組み合わせる
 */

import { AgeGroup } from '@/constants';
import { useChatArea } from './hooks/useChatArea';
import { ChatAreaContent } from './components/ChatAreaContent';

interface ChatAreaProps {
  sessionId: string;
  ageGroup: AgeGroup;
  sidebarOpen: boolean;
  onMessageSent?: () => void;
}

export const ChatArea = ({ sessionId, ageGroup, sidebarOpen, onMessageSent }: ChatAreaProps) => {
  const props = useChatArea({ sessionId, ageGroup, onMessageSent });

  return (
    <ChatAreaContent
      {...props}
      sidebarOpen={sidebarOpen}
      sessionId={sessionId}
      ageGroup={ageGroup}
    />
  );
};
